import AllProjects from "./AllProjects";

export default AllProjects;
